module.exports = __webpack_public_path__ + "media/images/veritrans_payment/Carrier_Docomo-633ef64eb382052c80548ef67199b1c4.gif";